import {
  Box,
  Grid,
  Typography,
  useTheme,
  useMediaQuery,
  DialogContent,
  Dialog,
} from "@mui/material";
import styles from "./PostRequirement.module.css";
import { customTextColor } from "../../utils/const";
import profile_image from "../../assets/images/ajit_image.jpeg";
import MatchesResultInternalResume from "../../components/containers/MatchesResultInternalResume";
import { useState } from "react";
import { IoIosArrowBack } from "react-icons/io";
import SideDrawer from "./SideDrawer";
import { LuShieldCheck } from "react-icons/lu";
import { PiUserCircleCheckFill } from "react-icons/pi";
import { IoSearchOutline } from "react-icons/io5";
import { IoIosSearch } from "react-icons/io";
import { PiMailboxLight } from "react-icons/pi";
import { CiMobile3 } from "react-icons/ci";
import { PiLinkedinLogoLight } from "react-icons/pi";
import SideIcon from "./SideIcon";

const ViewInternalCandidateResumeDetails = () => {
  const [open, setOpen] = useState(false);
  const [show, setShow] = useState(false);

  const handleCloseShow = () => setShow(false);
  const handleShow = () => setShow(true);

  const [oppen, setOppen] = useState(false);
  const [side, setSide] = useState(false);

  const handleCloseSide = () => setSide(false);
  const handleSide = () => setSide(true);

  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };
  const [typeResult, setTypeResult] = useState("public");
  return (
    // <RootComponents>
    <>
      {/* <Box className={styles.search_candidate_stucture}>
                <Box className={styles.job_serach_result_heading}>
                    <Typography sx={{ color: customTextColor }}>INTERNAL CANDIDATE PROFILE – VIEW BY RESUME HOLDER </Typography>
                </Box>

                <Grid container className={styles.matches_and_submit}>
                    <Grid item xs={12} sm={12} md={6} lg={6} sx={{ color: customTextColor }}>
                        <Box>
                            <Box className={styles.submit}>
                                <Typography><b style={{ fontSize: '24px' }}>95%</b></Typography>
                                <Typography>MATCHES WITH REQUIREMENT</Typography>
                            </Box>
                            <Typography>Name : <b>Kevin Macklin</b></Typography>
                            <Typography>Phone No : <b>242-330-****</b></Typography>
                            <Typography>Experience : <b>10 Years</b></Typography>
                            <Typography>Current Location : <b>Dallas Taxes</b></Typography>
                        </Box>
                    </Grid>

                    <Grid item xs={12} sm={12} md={6} lg={6} sx={{ color: customTextColor }}>
                        <Box>
                            <Box className={styles.submit}>
                                <Typography><b style={{ fontSize: '24px' }}>12-08-24</b></Typography>
                                <Typography>LAST SUBMITTED ON</Typography>
                            </Box>
                            <Typography>Job Profile : <b>Lead Java Developer</b></Typography>
                            <Typography>E-Mail ID : <b> kevinmaclin***@gmail.com</b></Typography>
                            <Typography>Work Authorization : <b> Green Card</b></Typography>
                            <Typography>Prefer Location : <b>San Club California, CA</b></Typography>
                        </Box>
                    </Grid>

                </Grid>

                <Grid container className={styles.profile_status}>

                    <Grid item xs={12} sm={12} md={6} lg={6} sx={{ color: customTextColor }}>
                        <Typography>Domain : <b>Healthcare, Retail, Banking</b></Typography>
                        <Typography>Qualifications : <b>B Tech</b></Typography>
                        <Typography>Prefer Tax Term : <b>Full Time, W2, Contract</b></Typography>
                    </Grid>
                    <Grid item xs={12} sm={12} md={6} lg={6} sx={{ color: customTextColor }}>
                        <Typography>Organization : <b>ABC Technologies Pvt Ltd</b></Typography>
                        <Typography>Current Rate : <b>100$</b></Typography>
                        <Typography>University : <b>Boston Texas</b></Typography>
                    </Grid>
                </Grid>

                <Box className={styles.skills_details}>
                    <Typography sx={{ marginBottom: '20px !important' }}>Excellency in skills</Typography>
                    <Grid container sx={{ fontweight: '600' }}>
                        <Grid item xs={6} sm={6} md={2.3} lg={2.3}>
                            <Box sx={{ color: customTextColor }}>
                                <Typography>Hibernate 2 Years  </Typography>
                                <Typography>Spring Boot 4 Years</Typography>
                                <Typography>AWS Could 1.5 Years</Typography>

                            </Box>
                        </Grid>
                        <Grid item xs={6} sm={6} md={3.5} lg={3.5} sx={{ borderLeft: "2px solid white", paddingLeft: '20px', }}>
                            <Box sx={{ color: customTextColor }}>
                                <Typography> MVC 1 Years</Typography>
                                <Typography>Spring Boot 4 Years</Typography>
                                <Typography>AWS Could 1.5 Years</Typography>
                            </Box>
                        </Grid>
                        <Grid item xs={6} sm={6} md={3.1} lg={3.1} sx={{ borderLeft: "2px solid white", paddingLeft: '20px' }}>
                            <Box sx={{ color: customTextColor, }}>
                                <Typography> Golang 2 Years </Typography>
                                <Typography>Spring Boot 4 Years</Typography>
                                <Typography>AWS Could 1.5 Years</Typography>
                            </Box>
                        </Grid>
                        <Grid item xs={6} sm={6} md={3.1} lg={3.1} sx={{ borderLeft: "2px solid white", paddingLeft: '20px', }}>
                            <Box sx={{ color: customTextColor, }}>
                                <Typography> Hibernate 2 Years </Typography>
                                <Typography>Spring Boot 4 Years </Typography>
                                <Typography>AWS Could 1.5 Years </Typography>
                            </Box>
                        </Grid>
                    </Grid>
                </Box>
                <Box className={styles.profile_status_details_btns}>
                    <img src={profile_image} alt="" />


                    <Box className={styles.add_back_btns} >
                        <button
                            style={{ backgroundColor: "#2e75b6", marginRight: '180px' }}
                        >
                            View Contact
                        </button>
                        <button style={{ backgroundColor: "#00b050"}}>                        
                            Send Requirement
                        </button>

                        <Box>
                            <button
                                style={{ backgroundColor: "#2e75b6", marginLeft: '150px' }}
                            >
                                Change status

                            </button>
                        </Box>
                    </Box>
                </Box>


            </Box> */}

      <Box className={styles.search_candidate_stucture}>
        <Box className={styles.job_serach_result_heading}>
          <Typography sx={{ color: customTextColor }}>
            Candidate Details
          </Typography>
          <span onClick={handleShow}>
            <Typography sx={{ color: customTextColor }}>
              Kevin Macklin - Submission History
            </Typography>
            <IoIosArrowBack
              className={styles.arrow_icon}
              style={{ color: "rgb(147 145 145)", fontSize: "18px" }}
            />
          </span>
        </Box>

        <SideIcon handleClose={handleCloseSide} side={side} />

        <Grid container className={styles.verification_phase}>
          <Grid
            item
            xs={12}
            sm={12}
            md={3}
            lg={3}
            sx={{ color: customTextColor, border: "none !important" }}
          >
            <Typography sx={{ marginLeft: "0 !important" }}>
              <b>Two Step Verification</b>{" "}
              <LuShieldCheck style={{ fontSize: "20px", color: "#54a6e6" }} />
            </Typography>
          </Grid>
          <Grid
            item
            xs={12}
            sm={12}
            md={3}
            lg={3}
            sx={{ color: customTextColor }}
          >
            <Typography>
              <b> Since 12 May 2024</b>
              <PiUserCircleCheckFill
                style={{ fontSize: "20px", color: "#54a6e6" }}
              />
            </Typography>
          </Grid>
          {/* <Grid
              item
              xs={12}
              sm={12}
              md={3}
              lg={3}
              sx={{ color: customTextColor }}
            >
              <Typography><b>Submitted on 12 May 2024</b><FaRegCheckCircle style={{ fontSize: "20px" }} /></Typography>
            </Grid> */}
          <Grid
            item
            xs={12}
            sm={12}
            md={3}
            lg={3}
            sx={{ color: customTextColor }}
          >
            <Typography>
              <b>
                <b> 95%</b>Searching Matches
              </b>
              <IoSearchOutline style={{ fontSize: "20px", color: "#54a6e6" }} />
            </Typography>
          </Grid>
          <Grid
            item
            xs={12}
            sm={12}
            md={3}
            lg={3}
            sx={{ color: customTextColor }}
          >
            <Typography sx={{ cursor: "pointer" }}>
              <b>Profile Active</b>
              <LuShieldCheck
                style={{ fontSize: "20px", color: "#54a6e6" }}
              />{" "}
            </Typography>
          </Grid>
        </Grid>

        <Box className={styles.profile_and_submit}>
          <Grid container>
            <Grid
              item
              xs={12}
              sm={12}
              md={6}
              lg={6}
              sx={{ color: customTextColor }}
            >
              <Box>
                <Typography>
                  <b>Profile Uploaded By</b>
                </Typography>

                <Typography sx={{ marginTop: "20px !important" }}>
                  Name: <b>Harish *****</b>
                </Typography>
                <Typography>
                  Designation: <b> Sr. Recruiter</b>
                </Typography>
                <Typography>
                  Profile Updated: <b>10 August 2024 </b>
                </Typography>
              </Box>
            </Grid>

            <Grid
              item
              xs={12}
              sm={12}
              md={6}
              lg={6}
              sx={{ color: customTextColor }}
            >
              <Box>
                <Typography sx={{ marginTop: "40px !important" }}>
                  {/* <b>Current Status</b> */}
                </Typography>
                <Typography>
                  Unique ID: <b>KM0012</b>
                </Typography>
                <Typography>
                  Rank in Searching: <b> 12</b>
                </Typography>
                <Typography>
                Candidate Category:
                  <b> Depended</b>
                </Typography>
              </Box>
            </Grid>
          </Grid>
        </Box>

        <Box className={styles.matches_and_submit}>
          <Grid container>
            <Grid
              item
              xs={12}
              sm={12}
              md={6}
              lg={6}
              sx={{ color: customTextColor }}
            >
              <Box>
                <Typography>
                  Name : <b>Kevin Macklin</b>
                </Typography>

                <Typography>
                  Experience : <b>10 Years</b>
                </Typography>
                <Typography>
                  Current Location : <b>Dallas Taxes</b>
                </Typography>
                <Typography>
                  Organization : <b>ABC Technologies Pvt Ltd</b>
                </Typography>

                <Typography>
                  Qualifications : <b>B Tech</b>
                </Typography>
                <Typography sx={{ marginBottom: "0 !important" }}>
                  Prefer Tax Term : <b>Any</b>
                </Typography>
              </Box>
            </Grid>

            <Grid
              item
              xs={12}
              sm={12}
              md={6}
              lg={6}
              sx={{
                color: customTextColor,
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <Box>
                <Typography>
                  Job Profile : <b>Lead Java Developer</b>
                </Typography>
                <Typography>
                  Work Authorization : <b> Green Card</b>
                </Typography>
                <Typography>
                  Prefer Location : <b>San Club California, CA</b>
                </Typography>
                <Typography>
                  Domain : <b>Healthcare, Retail, Banking</b>
                </Typography>
                <Typography>
                  University & Year : <b>Boston Texas,2024</b>
                </Typography>
                <Typography sx={{ marginBottom: "0 !important" }}>
                  Current Rate : <b>100$</b>
                </Typography>
              </Box>

              <Box>
                <span onClick={handleSide} style={{ cursor: "pointer" }}>
                  <Typography>
                    <div style={{ backgroundColor: "#e1eaf0", padding: "7px" }}>
                      <IoIosSearch style={{ fontSize: "22px" }} />
                    </div>
                  </Typography>
                </span>
                <Typography>
                  <div style={{ backgroundColor: "#e1eaf0", padding: "7px" }}>
                    <PiMailboxLight style={{ fontSize: "22px" }} />
                  </div>
                </Typography>
                <Typography>
                  <div style={{ backgroundColor: "#e1eaf0", padding: "7px" }}>
                    <CiMobile3 style={{ fontSize: "22px" }} />
                  </div>
                </Typography>
                <Typography>
                  <div style={{ backgroundColor: "#e1eaf0", padding: "7px" }}>
                    <PiLinkedinLogoLight style={{ fontSize: "22px" }} />
                  </div>
                </Typography>
              </Box>
            </Grid>
          </Grid>
        </Box>

        <Grid container sx={{ backgroundColor: "#fff" }}>
          <Grid item xs={6} sm={6} md={9} lg={9}>
            <Box className={styles.list_details}>
              <Typography sx={{ marginBottom: "20px !important" }}>
                Excellency in skills
              </Typography>
              <Grid container sx={{ fontweight: "600" }}>
                <Grid item xs={6} sm={6} md={2.3} lg={2.3}>
                  <Box sx={{ color: customTextColor }}>
                    <Typography>Hibernate 2 Years </Typography>
                    <Typography>Spring Boot 4 Years</Typography>
                    <Typography>Hibernate 2 Years</Typography>
                  </Box>
                </Grid>
                <Grid
                  item
                  xs={6}
                  sm={6}
                  md={3.5}
                  lg={3.5}
                  sx={{ borderLeft: "2px solid white", paddingLeft: "20px" }}
                >
                  <Box sx={{ color: customTextColor }}>
                    <Typography> MVC 1 Years</Typography>
                    <Typography>Spring Boot 4 Years</Typography>
                    <Typography>MVC 1 Years </Typography>
                  </Box>
                </Grid>
                <Grid
                  item
                  xs={6}
                  sm={6}
                  md={3.1}
                  lg={3.1}
                  sx={{ borderLeft: "2px solid white", paddingLeft: "20px" }}
                >
                  <Box sx={{ color: customTextColor }}>
                    <Typography> Golang 2 Years </Typography>
                    <Typography>Spring Boot 4 Years</Typography>
                    <Typography>Golang 2 Years </Typography>
                  </Box>
                </Grid>
                <Grid
                  item
                  xs={6}
                  sm={6}
                  md={3.1}
                  lg={3.1}
                  sx={{ borderLeft: "2px solid white", paddingLeft: "20px" }}
                >
                  <Box sx={{ color: customTextColor }}>
                    <Typography> Hibernate 2 Years </Typography>
                    <Typography>Spring Boot 4 Years </Typography>
                    <Typography>Hibernate 2 Years</Typography>
                  </Box>
                </Grid>
              </Grid>
            </Box>
          </Grid>
          <Grid item xs={6} sm={6} md={3} lg={3}>
            <Box className={styles.add_back_btns}>
              <button
                onClick={handleClickOpen}
                style={{
                  backgroundColor: "#4285f4",
                }}
              >
                Send Job
              </button>
            </Box>
          </Grid>
        </Grid>
        {/*         
        <Box className={styles.profile_status_details_btns}>
          <img src={profile_image} alt="" />

          <Box className={styles.add_back_btns}>
            <button
              style={{
                backgroundColor: "#2e75b6",
                marginRight: "350px",
              }}
            >
              View Contact
            </button>

            <Box>
              <button
                onClick={handleClickOpen}
                style={{
                  backgroundColor: "#00b050",
                  marginLeft: "150px",
                }}
              >
                Send Requirement
              </button>
            </Box>
         
          </Box>
        </Box> */}

        <SideDrawer
          handleShow={handleShow}
          handleClose={handleCloseShow}
          show={show}
        />
      </Box>

      <Dialog
        fullScreen={fullScreen}
        open={open}
        onClose={handleClose}
        aria-labelledby="responsive-dialog-title"
        maxWidth="lg"
        fullWidth={true}
      >
        <DialogContent>
          <Box className={styles.upload_resume_section}>
            <Box style={{ color: customTextColor }}>
              <Typography>
                <b>Available Credit</b>{" "}
              </Typography>
              <Typography sx={{ fontSize: "25px !important" }}>
                <b>1250</b>
              </Typography>
              <button>Add More Credit</button>
            </Box>
            <img src={profile_image} alt="" />
          </Box>
          <Box sx={{ margin: "10px" }}>
            <Typography>
              <b>
                {" "}
                50% credit will be reverse after respond from respective
                candidate.
              </b>
            </Typography>
          </Box>
          <Grid container className={styles.internal_details_field}>
            <Grid
              item
              xs={12}
              sm={12}
              md={6}
              lg={6}
              sx={{ padding: "10px 20px 10px 0" }}
            >
              <Typography>
                <b>Kevin Macklin </b>
              </Typography>
            </Grid>
            <Grid
              item
              xs={12}
              sm={12}
              md={6}
              lg={6}
              sx={{ padding: "10px 0 10px 20px" }}
            >
              <Typography>
                <b> Lead Java Developer</b>
              </Typography>
            </Grid>
            <Grid
              item
              xs={12}
              sm={12}
              md={6}
              lg={6}
              sx={{ padding: "10px 20px 10px 0" }}
            >
              <Typography>
                <b>Green Card</b>{" "}
              </Typography>
            </Grid>
            <Grid
              item
              xs={12}
              sm={12}
              md={6}
              lg={6}
              sx={{ padding: "10px 0 10px 20px" }}
            >
              <Typography>
                <b>Dallas Taxes</b>{" "}
              </Typography>
            </Grid>
            <Grid
              item
              xs={12}
              sm={12}
              md={6}
              lg={6}
              sx={{ padding: "10px 20px 10px 0" }}
            >
              <Typography>
                <b>Current Company: General Motors </b>{" "}
              </Typography>
            </Grid>
            <Grid
              item
              xs={12}
              sm={12}
              md={6}
              lg={6}
              sx={{ padding: "10px 0 10px 20px" }}
            >
              <Typography>
                <b>Client Name: Need to enter manually</b>
              </Typography>
            </Grid>
          </Grid>
          <Box className={styles.request_submit}>
            <button onClick={handleClose}>Request to Submit</button>
          </Box>
        </DialogContent>
      </Dialog>

      <Grid
        item
        xs={12}
        sm={12}
        md={12}
        lg={12}
        sx={{ padding: "10px 20px 10px 20px" }}
      >
        <Box className={styles.second_resume}>
          <Typography
            onClick={() => setTypeResult("public")}
            sx={
              typeResult === "public"
                ? { color: "black" }
                : { color: customTextColor }
            }
          >
            120 Similar Results
          </Typography>
          {/* <Typography
            onClick={() => setTypeResult("internal")}
            sx={
              typeResult === "internal"
                ? { color: "#95cb6d" }
                : { color: customTextColor }
            }
          >
            Internal Resume
          </Typography> */}
        </Box>
      </Grid>

      <Grid
        item
        xs={12}
        sm={12}
        md={12}
        lg={12}
        sx={{ padding: "10px 20px 10px 20px" }}
      >
        {typeResult === "public" ? (
          <>
            <MatchesResultInternalResume
              name="Himanshu Sekhar"
              job=" Lead Java Developer"
              location="Noida Delhi, DL"
              salary="Rs 30k PM"
              skills="Hibernate 2 Years | Spring Boot 4 Years | ASW Cloud 2 Years | GO 2 Years"
              btn1="Get Resume"
              matches="Mathes 97%"
            />
            <MatchesResultInternalResume
              name=" Pratik Reddy"
              job=" Lead Java Developer"
              location="Kolkata, KK"
              salary="Rs 25k PM"
              skills=" Hibernate 2 Years | Spring Boot 4 Years | ASW Cloud 2 Years | GO 2 Years"
              btn1="Get Resume"
              matches="Mathes 95%"
            />
            <MatchesResultInternalResume
              name=" Pratik Reddy"
              job=" Lead Java Developer"
              location="Kolkata, KK"
              salary="Rs 25k PM"
              skills=" Hibernate 2 Years | Spring Boot 4 Years | ASW Cloud 2 Years | GO 2 Years"
              btn1="Get Resume"
              matches="Mathes 95%"
            />
          </>
        ) : (
          <></>
        )}
      </Grid>

      <Box className={styles.select_search_result_btns}>
        <button style={{ alignSelf: "flex-end " }}>Select All</button>
      </Box>
    </>
    // </RootComponents>
  );
};

export default ViewInternalCandidateResumeDetails;
